import React, { useState, useEffect } from 'react';
import { getWeather, getWeatherNextDays } from './WeatherService';
import './Weather.css';

const Weather = () => {
  const [city, setCity] = useState('Buxar');
  const [weather, setWeather] = useState(null);
  const [forecast, setForecast] = useState(null);

  const handleSearch = async () => {
    try {
      const weatherResponse = await getWeather(city);
      setWeather(weatherResponse.data);

      const forecastResponse = await getWeatherNextDays(city);
      setForecast(forecastResponse.data);
    } catch (error) {
      console.error('Error fetching weather data:', error);
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div className="main">
      <div className="item">
        <input
          type="text"
          placeholder="Search City"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>
      <div className="maindata">
        {weather && (
          <div className="card">
            <div className="container">
              <div className="cloud front">
                <span className="left-front"></span>
                <span className="right-front"></span>
              </div>
              <span className="sun sunshine"></span>
              <span className="sun"></span>
              <div className="cloud back">
                <span className="left-back"></span>
                <span className="right-back"></span>
              </div>
            </div>

            <div className="card-header">
              <span>{weather.name}</span>
              <span>{new Date().toDateString()}</span>
            </div>

            <span className="temp">{weather.main.temp}°C</span>

            <div className="temp-scale">
              <span>Celcius</span>
            </div>

            <div className="details">
              <p>Min: {weather.main.temp_min}°C</p>
              <p>Max: {weather.main.temp_max}°C</p>
              <p>Humidity: {weather.main.humidity}%</p>
              <p>Wind: {weather.wind.speed} m/s</p>
              <p>Sunrise: {new Date(weather.sys.sunrise * 1000).toLocaleTimeString()}</p>
              <p>Sunset: {new Date(weather.sys.sunset * 1000).toLocaleTimeString()}</p>
              <p>Description: {weather.weather[0].description}</p>
            </div>
          </div>
        )}

        {forecast && (
          <div className="forecast">
            <h3 className='h3'>Next Days Forecast</h3>
            {forecast.list.slice(1, 5).map((item, index) => (
              <div className="forecast-day" key={index}>
                <p className="forecast-date">Day {index + 2}</p>
                <p className="forecast-temp">{item.main.temp}°C</p>
                <p className="forecast-desc">{item.weather[0].description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>

  );
};

export default Weather;
